import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder } from '../http'; // The API returns the singular name of the attribute type, so we remove the "s",
// except for userProfileAttributeDefinitions and datastoreFormAttributeDefinitions
// TODO: KCORE-2982

var responseEnvelope = function responseEnvelope(attributeType) {
  return ['userProfileAttributeDefinitions', 'datastoreFormAttributeDefinitions'].includes(attributeType) ? attributeType : attributeType.replace(/s$/, '');
};

var validateOptions = function validateOptions(functionName, requiredOptions, options) {
  var validAttributes = ['spaceAttributeDefinitions', 'teamAttributeDefinitions', 'userAttributeDefinitions', 'userProfileAttributeDefinitions', 'categoryAttributeDefinitions', 'kappAttributeDefinitions', 'formAttributeDefinitions', 'datastoreFormAttributeDefinitions'];
  var attributesRequiringKappSlug = ['categoryAttributeDefinitions', 'kappAttributeDefinitions', 'formAttributeDefinitions'];
  var kappSlugMissing = attributesRequiringKappSlug.includes(options.attributeType) && !options.kappSlug;
  var invalidType = !validAttributes.includes(options.attributeType);
  var missing = requiredOptions.filter(function (requiredOption) {
    return !options[requiredOption];
  });

  if (missing.length > 0) {
    throw new Error("".concat(functionName, " failed! The following required options are missing: ").concat(missing));
  }

  if (kappSlugMissing) {
    throw new Error("".concat(functionName, " failed! A kappSlug is required when using ").concat(options.attributeType));
  }

  if (invalidType) {
    throw new Error("".concat(functionName, " failed! The provided attributeType (").concat(options.attributeType, ") is not valid"));
  }
};

var buildEndpoint = function buildEndpoint(_ref) {
  var attributeType = _ref.attributeType,
      kappSlug = _ref.kappSlug,
      attributeName = _ref.attributeName;
  var basePath = kappSlug ? "".concat(bundle.apiLocation(), "/kapps/").concat(kappSlug, "/").concat(attributeType) : "".concat(bundle.apiLocation(), "/").concat(attributeType);
  return attributeName ? "".concat(basePath, "/").concat(attributeName) : basePath;
};

export var fetchAttributeDefinitions = function fetchAttributeDefinitions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var attributeType = options.attributeType;
  validateOptions('fetchAttributeDefinitions', ['attributeType'], options);
  return axios.get(buildEndpoint(options), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      attributeDefinitions: response.data[attributeType]
    };
  })["catch"](handleErrors);
};
export var fetchAttributeDefinition = function fetchAttributeDefinition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var attributeType = options.attributeType;
  validateOptions('fetchAttributeDefinition', ['attributeType', 'attributeName'], options);
  return axios.get(buildEndpoint(options), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      attributeDefinition: response.data[responseEnvelope(attributeType)]
    };
  })["catch"](handleErrors);
};
export var createAttributeDefinition = function createAttributeDefinition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var kappSlug = options.kappSlug,
      attributeType = options.attributeType,
      attributeDefinition = options.attributeDefinition;
  validateOptions('createAttributeDefinition', ['attributeType', 'attributeDefinition'], options); // For Creates, we don't append the name to the basePath (it goes in the body)
  // so not using the buildEndpoint function

  var basePath = kappSlug ? "".concat(bundle.apiLocation(), "/kapps/").concat(kappSlug, "/").concat(attributeType) : "".concat(bundle.apiLocation(), "/").concat(attributeType); // The API returns the singular name of the attribute type, so we remove the "s"

  return axios.post(basePath, attributeDefinition, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      attributeDefinition: response.data[responseEnvelope(attributeType)]
    };
  })["catch"](handleErrors);
};
export var updateAttributeDefinition = function updateAttributeDefinition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var attributeType = options.attributeType,
      attributeDefinition = options.attributeDefinition;
  validateOptions('updateAttributeDefinition', ['attributeType', 'attributeName'], options); // The API returns the singular name of the attribute type, so we remove the "s"

  return axios.put(buildEndpoint(options), attributeDefinition, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      attributeDefinition: response.data[responseEnvelope(attributeType)]
    };
  })["catch"](handleErrors);
};
export var deleteAttributeDefinition = function deleteAttributeDefinition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var attributeType = options.attributeType;
  validateOptions('deleteAttributeDefinition', ['attributeType', 'attributeName'], options); // Build URL and fetch the space.

  return axios["delete"](buildEndpoint(options), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      attributeDefinition: response.data[responseEnvelope(attributeType)]
    };
  })["catch"](handleErrors);
};